import React, { Component } from 'react'
//import video from './Videos.video1.mp4'
import "../src/Transactions/Transaction.css";
import video from "./assets/images/RVM.mp4";
import Header from "./Common/Header/Header";
import Constant from './constant/Constant';
import "./Common/Header/Header.css";

class Video extends Component {
  render() {
    return (
      <>
        <div className="App">
          <Header />
          <div className='video' style={{ display: 'flex', padding: '25px', justifyContent: "center"}}>
            <video src={Constant.VIDEO_BASE_URL + 'RVM.mp4'} controls>
            {/* <video src={video} controls> */}
            </video>
          </div>
        </div>
      </>
    );
  }   
}
export default Video;
